import { Environments, getEnvironmentFromHost } from '../api/endpoints';
import { ClubCode, envMapForJoinUrl } from './constants';
import { getClubContent, ClubContentName } from './getClubContent';
import CookieHelper from './cookieHelper';
import { urlClubCodeMap } from './urlClubCodeMap';

export const generateJoinURL = (clubcode: string, zipcodeentry: string, campaigncode?: any) => {
  const env = getEnvironmentFromHost(window.location.hostname);
  const joinEnv = envMapForJoinUrl[env] || 'apps';
  const clubCode = clubcode ? clubcode : CookieHelper.getClubCodeFromZipcodeCookie() || '';
  const zipCode = zipcodeentry ? zipcodeentry : CookieHelper.getZipcodeFromZipcodeCookie() || '';
  const club =
    getClubContent(ClubContentName.CodeClubUrl, clubCode) ||
    getClubContent(ClubContentName.CodeClubUrl, ClubCode.calif);
  let url = `https://${joinEnv}.${club}.aaa.com/aceapps/membership/JoinNow/Start?flowName=NewBiz&clubcode=${clubCode}&zipcodeentry=${zipCode}`;

  if (campaigncode) {
    url += `&campaigncode=${campaigncode}`;
  }

  return url;
};
export const generateGiftURL = (clubcode: string) => {
  const env = getEnvironmentFromHost(window.location.hostname);
  const giftEnv = envMapForJoinUrl[env] || 'apps';
  const clubCode = clubcode ? clubcode : CookieHelper.getClubCodeFromZipcodeCookie() || '';

  const club =
    getClubContent(ClubContentName.CodeClubUrl, clubCode) ||
    getClubContent(ClubContentName.CodeClubUrl, ClubCode.calif);
  let url = `https://${giftEnv}.${club}.aaa.com/aceapps/membership/GiftMembership/SelectMembershipLevel?flowName=Gift`;

  return url;
};
export const getAwsDomainUrl = (hostname: string) => {
  if (hostname.search('localhost') > -1 || hostname.startsWith('appdev1') || hostname.startsWith('app.dev')) {
    return 'https://appdev1.ace.aaa.com';
  } else if (hostname.startsWith('appdev2')) {
    return 'https://appdev2.ace.aaa.com';
  } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa')) {
    return 'https://appqa1.ace.aaa.com';
  } else if (hostname.startsWith('appqa2')) {
    return 'https://appqa2.ace.aaa.com';
  } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat')) {
    return 'https://appuat1.ace.aaa.com';
  } else if (hostname.startsWith('appuat2')) {
    return 'https://appuat2.ace.aaa.com';
  } else if (hostname.startsWith('app')) {
    return 'https://app.ace.aaa.com';
  } else {
    return 'https://app.ace.aaa.com';
  }
};

export const generateMembershipCardUrlLegacy = (clubCode: string) => {
  const env = getEnvironmentFromHost(window.location.hostname);
  const domain = env === Environments.prod ? 'apps' : 'uatmvc';
  return `https://${domain}.${urlClubCodeMap[clubCode]}.aaa.com/aceapps/replacementcard/request`;
};
export const generateMembershipCardUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  const domain = env === Environments.prod ? 'app' : 'app' + env + '1';
  return `https://${domain}.ace.aaa.com/membership/replacementcard`;
};

export const autopayLink = (sessionId: string) => {
  return `${getAwsDomainUrl(window.location.hostname)}/payments/manage-autopay?memcid=${sessionId}`;
};
